
import AppProductSkuAutocomplete from "@/components/products/ProductSkuAutocompleteWithoutModal.vue";
import { Product } from "@/models/base";
import { ProductService } from "@/services/product-service";
import Vue from "vue";
import AppEditProduct from "./ProductEditCard.vue";
import { UserConfigService } from "../../services/user-config-service";
import { HttpError } from "@/utils/services/http-error";
import { DossierConfigService } from "@/services/dossier-config-service";
import { PriceListProductService } from "@/services/price-list-product-service";
import {AuthService} from "@/services";
import {MODULE} from "@/config/modules";

export default Vue.extend({
	data() {
		return {
			toCreateProduct: null as null | Product,
			text: "",
			dontTriggerBlur: false,
			onReadyToBlurHandlers: null as null | Function[],
		};
	},
	props: {
		value: Object as () => Product,
		createModalIfNotExist: Boolean,
		label: [Object, String],
		autoFocus: Boolean,
		disabled: Boolean,
		includeDisabled: Boolean,
		allowMultiple: Boolean,
		removeOnEmpty: Boolean,
		showStockLocation: Number
	},
	computed: {
		isOpened():boolean {
			let el = this.$refs.productSku as any;
			if (!el) return false;
			return el.isOpened;
		},
		hasPriceListModule():boolean{
			return AuthService.hasModule(MODULE.EXTERNE_PRODUCT_CATALOGUS);
		},
	},
	methods: {
		async isReadyToBlur():Promise<void>{
			let skuEl = this.$refs.productSku as any;
			if (!skuEl) return;
			await skuEl.isReadyToBlur();
			if (!this.onReadyToBlurHandlers) {
				return;
			}
			return new Promise((resolve)=>{
				if (!this.onReadyToBlurHandlers){
					return resolve();
				}
				this.onReadyToBlurHandlers.push(resolve);
			});
		},
		focus() {
			(this.$refs.productSku as any).focus();
			this.dontTriggerBlur = false;
		},
		multipleProductsSelected(products:Product[]){
			this.dontTriggerBlur = true;
			this.$emit("inputs", products);
		},
		productSelected(product: Product) {
			this.dontTriggerBlur = true;
			this.$emit("input", product);
		},
		// eslint-disable-next-line max-lines-per-function
		async onBlur() {
			if (this.dontTriggerBlur) {
				this.dontTriggerBlur = false;
				return;
			}
			if (!this.text || !this.text.trim()) {
				this.$emit("input", null);
				return;
			}
			// Skip fetch/emit if the SKU hasn't changed from the currently selected product
			if (this.value && this.value.Sku && this.value.Sku.trim().toUpperCase() == this.text.trim().toUpperCase()) {
				return;
			}
			this.onReadyToBlurHandlers = [];
			try {
				let product = await ProductService.findBySku(this.text);
				this.$emit("input", product);
			} catch (e:any) {
				let err = e as HttpError;
				if (err.key == "ELEMENT_NOT_FOUND") {
					err.dontShow = true;
					let exists = await ProductService.existsBySkuIncludeNonActive(this.text);
					if (exists) {
						let text = this.$ct("product-is-inactive");
						await this.$wf.dialog(text, this.$ct("common.ok"), this.$ct("common.warning"), "warning");
						return;
					}
					if (!this.createModalIfNotExist || !UserConfigService.hasCurrentUserPermission((p)=>p.ProductPermissions.hasWritePermissions())) {
						return this.$wf.notify(this.$ct("product-not-found"), "danger", 3000, "exclamation-triangle");
					}
					let result;
					//check price-list
					let plProd = null;
					if(this.hasPriceListModule){
						plProd = await PriceListProductService.findBySku(this.text);
					}
					if(plProd?.ID){
						let builder = this.$confirmBuilder(this.$ct("found-in-pricelist"));
						builder.setTitle(this.$t("common.info"));
						result = await builder.show();
						if (result) {
							this.toCreateProduct = await PriceListProductService.toProduct(plProd);
							this.toCreateProduct.Active = true;
							if (this.toCreateProduct.ExtraFields){
								DossierConfigService.getExtraFieldNamesConfigs().ProspectNames.setDefaultValues(this.toCreateProduct.ExtraFields);
							}
						}
					}else{
						let builder = this.$confirmBuilder(this.$ct("product-not-exists-create"));
						builder.setTitle(this.$t("common.info"));
						result = await builder.show();
						if (result) {
							this.toCreateProduct = new Product();
							this.toCreateProduct.Sku = this.text;
							if (this.toCreateProduct.ExtraFields){
								DossierConfigService.getExtraFieldNamesConfigs().ProspectNames.setDefaultValues(this.toCreateProduct.ExtraFields);
							}
						}
					}
				}
			}finally{
				for (let i = this.onReadyToBlurHandlers.length - 1; i>=0; i--){
					this.onReadyToBlurHandlers[i]();
					this.onReadyToBlurHandlers.pop();
				}
				this.onReadyToBlurHandlers = null;
			}
		},
		cancelCreateProduct() {
			this.toCreateProduct = null;
		},
		async finishCreateProduct(product: Product) {
			product = await ProductService.getProduct(product.ID);
			this.$emit("input", product);
			this.toCreateProduct = null;
		},
		onKeyUp(event:KeyboardEvent) {
			this.dontTriggerBlur = false;
			this.$emit("keyup", event);
		},
		clear() {
			(this.$refs.productSku as any).clear();
		},
		onText(event:string){
			this.text = event;
		},
		openSearchBrowse(searchString?:string) {
			if (!this.$refs.productSku) return;
			(this.$refs.productSku as any).searchProducts(searchString);
		},
		openCreateProduct(sku:string | null = null){
			let product = new Product();
			product.Sku = sku || null;
			this.toCreateProduct = product;
		}
	},
	components: {
		AppEditProduct,
		AppProductSkuAutocomplete
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
